import { BASE_API_URL } from "../../config/Api";
import { GEM_BID_LIST, GEM_ENABLE_FILTER_LIST, INSERT_FILTER, MINISTRY_LIST, ORGANIZATION_LIST, ADD_BID_TO_FAVOURITE, ADD_CUSTOMER_DATA, PENDING_GEM_BID_LIST, COMPLETED_GEM_BID_LIST, CUSTOMER_LIST, ADD_GEM_BID_DATA_DETAILS, GEM_BID_DATA_DONE } from "./ActionType";

export const getBidList = (token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/get-bid-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: GEM_BID_LIST, payload: resData })
    } catch (error) {
        console.error("Error fetching gem bid list:", error);

    }
}

export const getGemEnableFiltersList = (token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/get-enable-filters-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: GEM_ENABLE_FILTER_LIST, payload: resData })
    } catch (error) {
        console.error("Error fetching gem enable filter list:", error);
    }
}

export const insertFilter = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/insert-gem-enable-filters`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: INSERT_FILTER, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in inserting gem filter:", error);
    }
}

export const getMinistryList = (token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/get-ministry-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: MINISTRY_LIST, payload: resData })
    } catch (error) {
        console.error("Error in fetching ministry list:", error);
    }
}

export const getOrganizationList = (ministryId, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/get-organization-list?ministryId=${ministryId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: ORGANIZATION_LIST, payload: resData })
    } catch (error) {
        console.error("Error in fetching organization list:", error);
    }
}

export const addBidToPendingList = (bidId, token) => async (dispatch) => {
    try {
        const res = await fetch(
            `${BASE_API_URL}/api/gemFilter/add-bid-to-pending-list?bidId=${bidId}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_BID_TO_FAVOURITE, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || resData.statusMessage || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in marking the bid as favorite:", error);
        return { success: false, error: "Something went wrong" };
    }
};

export const getCompletedGemBidList = (fromDate, toDate, token) => async (dispatch) => {
    try {
        const safeFromDate = fromDate || "";
        const safeToDate = toDate || "";
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/completed-gem-bid-list?fromDate=${safeFromDate}&toDate=${safeToDate}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: COMPLETED_GEM_BID_LIST, payload: resData })
    } catch (error) {
        console.error("Error fetching favorite gem bid list:", error);

    }
};
export const getPendingGemBidList = (token) => async (dispatch) => {
    try {

        const res = await fetch(`${BASE_API_URL}/api/gemFilter/pending-gem-bid-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: PENDING_GEM_BID_LIST, payload: resData })
    } catch (error) {
        console.error("Error fetching favorite gem bid list:", error);

    }
};

export const getCustomerList = (token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/get-customer-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        dispatch({ type: CUSTOMER_LIST, payload: resData })
    } catch (error) {
        console.error("Error in fetching customer list:", error);
    }
};

export const addGemBidDetails = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/add-gem-bid-details`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_GEM_BID_DATA_DETAILS, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in inserting gem filter:", error);
    }
}
export const addCustomerData = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/add-customer-data`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_CUSTOMER_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in inserting gem filter:", error);
    }
}
export const markGemBidPendingToDone = (bidDataId, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/api/gemFilter/mark-gem-penidng-todone?bidDataId=${bidDataId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: GEM_BID_DATA_DONE, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in inserting gem filter:", error);
    }
}
